import type { CameraApiResponse } from "@src/services/api/cameras-api";
import { getSiteName, getSiteString } from "@src/utils/key-parser";
import { sortCameras, type CameraSortOption } from "./camera-sort";

export type CameraSiteGroup = {
  siteId: string;
  siteName: string;
  siteSubtitle?: string;
  cameras: CameraApiResponse[];
};

export function groupCamerasBySite(
  cameras: CameraApiResponse[],
  sortBy: CameraSortOption[] | CameraSortOption,
): CameraSiteGroup[] {
  if (!cameras || cameras.length === 0) return [];

  const normalizedSort = Array.isArray(sortBy) && sortBy.length === 0 ? "id" : sortBy;
  const sorted = sortCameras(cameras, normalizedSort);
  const groups = new Map<string, CameraSiteGroup>();
  const orderedGroups: CameraSiteGroup[] = [];

  for (const camera of sorted) {
    const siteId = getSiteString(camera);
    let group = groups.get(siteId);

    if (!group) {
      const { name, subtitle } = getSiteName(camera, siteId);
      group = {
        siteId,
        siteName: name,
        siteSubtitle: subtitle,
        cameras: [],
      };
      groups.set(siteId, group);
      orderedGroups.push(group);
    }

    group.cameras.push(camera);
  }

  return orderedGroups;
}
